/**
 * Generated bundle index. Do not edit.
 */

export * from './model';
